import { render, staticRenderFns } from "./ViewFlagDetailsModal.vue?vue&type=template&id=70715842&scoped=true&"
import script from "./ViewFlagDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ViewFlagDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70715842",
  null
  
)

export default component.exports